import { render, staticRenderFns } from "./FormFieldV2.vue?vue&type=template&id=867c4b1e&scoped=true&"
import script from "./FormFieldV2.vue?vue&type=script&lang=js&"
export * from "./FormFieldV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867c4b1e",
  null
  
)

export default component.exports